import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getCrewDetails } from "../Actions/CrewManagement";
import logo from "../Asset/download.jpg";
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import swal from "sweetalert";
import { searchCrewMgmt } from "../Actions/CrewManagement";
import Role from "../helpers/role";

const SearchItem = {
  crewId: "",
  name: "",
  shipName: "",
  designation: "",
  fromDate: "",
  toDate: "",
  designation: "",
  shipId: 0,
  clientId: 0,
  PageNumber: 1,
  PageSize: 25,
};
let userRole = localStorage.getItem("UserRoles");

class CrewManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      crewData: {
        CrewId: "",
        name: "",
        shipName: "",
        designation: "",
        clientId: 0,
        photo: "",
        photoName: "",
        crewMemberId: "",
        isDeleted: true,
      },
    };
    this.UpdateData = this.UpdateData.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getCrewDetails(id));
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, CrewDetails } = nextProps;
    if (CrewDetails && CrewDetails !== "") {
      prevState.crewData.CrewId = CrewDetails.crewId;
      prevState.crewData.name = CrewDetails.name;
      prevState.crewData.shipName = CrewDetails.shipName;
      prevState.crewData.designation = CrewDetails.designation;
      prevState.crewData.photoName = CrewDetails.photoName;
      prevState.crewData.photo = CrewDetails.photo;
      prevState.crewData.crewMemberId = CrewDetails.crewMemberId;
      dispatch({ type: "ClientUserDetails", data: "" });
    }
  }

  componentDidUpdate() {
    const { dispatch, match } = this.props;
    window.onpopstate = (e) => {
      //your code...
      this.setState({ showSidePane: false });
      dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/CrewManagement");

      //   this.props.history.push("/Home/Management/Device");
    };
  }
  ShowSidePanel = () => {
    if (userRole == Role.staff) {
      this.setState({ showSidePane: false });
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/CrewManagement");
    } else {
      this.setState({ showSidePane: false });
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/CrewManagement");
    }
  };


  render() {
    const { CrewDetails } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row pt-4 pb-3"> </div>
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.ShowSidePanel()}
                  >
                    <div style={{ position: 'relative' }}>
                      <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                    </div>
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Crew Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-2 m-auto text-right">
                          <div className="text-center rounded-circle">
                            <img
                              src={
                                CrewDetails && CrewDetails.photo
                                  ? CrewDetails.photo
                                  : logo
                              }
                              alt="Smiley face"
                              height="70px !important"
                              style={{ width: "90%" }}
                              class="rounded-circle"
                            ></img>
                          </div>
                        </div>
                        <div className="col-sm-10">
                          <div className="row">
                            <div className="col-sm-12">
                              <label className="form-label">Crew ID :</label>
                              <span>
                                {" "}
                                {CrewDetails ? CrewDetails.crewId : ""}
                              </span>
                            </div>
                            <div className="col-sm-6">
                              <label className="form-label">Name :</label>
                              <span>
                                {" "}
                                {CrewDetails ? CrewDetails.name : ""}
                              </span>
                            </div>
                            <div className="col-sm-6">
                              <label className="form-label">Rank :</label>
                              <span>
                                {" "}
                                {CrewDetails ? CrewDetails.designation : ""}
                              </span>
                            </div>
                            <div className="col-lg-12">
                              <label className="form-label">
                                Ship Name :
                              </label>
                              <span>
                                {" "}
                                {CrewDetails ? CrewDetails.shipName : ""}
                              </span>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        {userRole == Role.mmpl ? (<>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ShowSidePanel()}
                          >
                            {" "}
                            Cancel{" "}
                          </button>
                        </>) :
                          userRole == Role.staff ? (<>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.UpdateData(CrewDetails)}
                            >
                              {" "}
                              Delete{" "}
                            </button></>) : (<>
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.EditClientDetails(CrewDetails)}
                              >
                                {" "}
                                Edit{" "}
                              </button>
                              <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                type="button"
                                onClick={() => this.UpdateData(CrewDetails)}
                              >
                                {" "}
                                Delete{" "}
                              </button>
                            </>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  EditClientDetails(item) {
    const { clientUserList, dispatch, history } = this.props;
    if (item?.isSyncing === true) {
      swal("Error!", "This crew is syncing with device. Not able to modify.", "warning");
      return;
    } else {
      dispatch({ type: "ClientUserDetails", data: item });
      this.props.history.push(`/Home/Management/EditCrew/${item.crewMemberId}`);
      dispatch({ type: "ShowSidePan", data: false });
    }

  }

  UpdateData(item) {
    const { dispatch, history } = this.props;
    if (item?.isSyncing === true) {
      swal("Error!", "This crew is syncing with device. Not able to delete.", "warning");
      return;
    } else {
      dispatch({ type: "ShowShipName", data: true });
      confirmAlert({
        message: "Are you sure want to delete?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              let url = `${API.UpdateCrew}`;
              axios
                .put(url, this.state.crewData)
                .then((response) => {
                  this.setState({ showSidePane: false });
                  this.ShowSidePanel();
                  dispatch(searchCrewMgmt(SearchItem, 1));
                  dispatch({
                    type: "UpdateCrewDetailSuccess",
                    data: response.data,
                  });
                  toast.success("Deleted Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  dispatch({ type: "ShowShipName", data: false });
                  dispatch({ type: "ClearSearchValues", data: true });
                })
                .catch((error) => {
                  swal("Error!", "Something went wrong. Please try again.", "warning");
                  dispatch({
                    type: "UpdateCrewDetailFailure",
                    data: "error",
                  });
                });
            },
          },
          {
            label: "No",
            onClick: () => {
              dispatch({ type: "ShowShipName", data: false });
            },
          },
        ],
        overlayClassName: 'custom-alert'
      });
    }
  }

}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    CrewDetails: state.CrewManagementReducer.CrewDetails,
    //     CrewDetails:
    //         {
    //             "crewID": "ABC121",
    //             "name": "Test Crew Member",
    //             "designation": "Staff",
    //             "shipName": "Ship 1",
    //             "photo": "new.img"
    // },
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CrewManagementDetail)
);
